import { makeAutoObservable } from 'mobx';
import { apiClient } from '../api/apiclient';
class HelloStore {
    constructor() {
        this.message = '';
        this.loading = false;
        this.error = null;
        makeAutoObservable(this);
    }
    async fetchHelloMessage() {
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.get('/hello');
            this.message = response.data.message;
        }
        catch (error) {
            this.error = 'Failed to fetch hello message';
            console.error('Error fetching hello message:', error);
        }
        finally {
            this.loading = false;
        }
    }
    clearMessage() {
        this.message = '';
        this.error = null;
    }
}
export const helloStore = new HelloStore();
